import React from "react"
import { FaGithub } from "react-icons/fa"
import hex2rgba from "hex2rgba"
import fmt from "human-format"

const roundToNearest = (num, increment) =>
  Math.floor(num / increment) * increment

const GithubStats = () => {
  // Last updated: 8/10/2020. These #'s used to come from gatsby-source-graphql but would get rate limited
  // by GitHub on occasion and cause builds to fail, hardcoding removes reliance on that API.
  const TOTAL_CONTRIBUTORS = 3464
  const TOTAL_STARGAZERS = 43600
  return (
    <a
      href="https://github.com/gatsbyjs/gatsby"
      title="GitHub"
      css={theme => ({
        alignItems: `center`,
        color: hex2rgba(theme.colors.purple[20], 0.5),
        display: `inline-flex`,
        fontSize: theme.fontSizes[1],
        textDecoration: `none`,
        transition: `all ${theme.transitions.speed.default} ${theme.transitions.curve.default}`,
        ":hover": {
          color: theme.colors.purple[20],
        },
      })}
    >
      <FaGithub
        css={theme => ({
          fontSize: theme.fontSizes[2],
          marginRight: theme.space[3],
        })}
      />
      {` `}
      {roundToNearest(TOTAL_CONTRIBUTORS, 50)}+ contributors,
      {` `}
      {fmt(TOTAL_STARGAZERS, { decimals: 1 })} stars
    </a>
  )
}

export default GithubStats
